<template>
    <div>
        <hd-header></hd-header>
        <div style="width: 400px;position: relative;" :style="{top:mainTop+'px', left:mainLeft+'px'}" ref="mainDiv">
            <div style="font-size: 24px;">找回密码</div>
            <span style="font-size: 14px;color: #999999;">验证码将会发送至你的手机</span>
            <div class="divSwitch">
                <span @click="switchType('mobile')"
                      :class="{spanSelected:typeIsMobile}">手机找回</span>
                <span @click="switchType('email')" :class="{spanSelected:typeIsEmail}"
                      style="margin-left: 90px">邮箱找回</span>
            </div>
            <div style="padding-top: 1em;" v-if="typeIsMobile">
                <div class="divInput">
                    <el-input placeholder="请输入手机号" prefix-icon="iconfont icon-shouji" v-model="mobile"></el-input>
                </div>
                <div class="divInput" style="display: flex;">
                    <el-input placeholder="请输入短信验证码" prefix-icon="iconfont icon-yanzhengma1"
                              style="width: 70%" v-model="mobileCode"></el-input>
                    <el-button style="width: 30%;margin-left: 0.5em;" type="primary" plain="plain"
                               @click="sendMobileCode">{{
                            sendBtnText
                        }}
                    </el-button>
                </div>
            </div>
            <div style="padding-top: 1em;" v-if="typeIsEmail">
                <div class="divInput">
                    <el-input placeholder="请输入邮箱地址" prefix-icon="iconfont icon-mail" v-model="email"></el-input>
                </div>
                <div class="divInput" style="display: flex;">
                    <el-input placeholder="请输入邮箱验证码" prefix-icon="iconfont icon-yanzhengma1"
                              style="width: 70%" v-model="emailCode"></el-input>
                    <el-button style="width: 30%;margin-left: 0.5em;" type="primary" plain="plain"
                               @click="sendEmailCode">{{
                            sendBtnText
                        }}
                    </el-button>
                </div>
            </div>
            <div class="divInput">
                <el-button type="primary" style="width: 100%;" @click="nextStep">下一步</el-button>
            </div>
            <div style="font-size: 14px;color: #999999;">
                如果无法解决问题，请联系 025-83222270
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdHeader from '../public/Header'
import HdFooter from '../public/FooterLogined'

export default {
    name: 'GetBackPassword',
    components: {
        HdHeader,
        HdFooter
    },
    created () {
    },
    mounted () {
        let that = this
        this.$nextTick(function () {
            that.setPanelPosition()
        })
    },
    data () {
        return {
            mainTop: 0,
            mainLeft: 0,
            typeIsMobile: true,
            typeIsEmail: false,
            mobile: '',
            mobileCode: '',
            email: '',
            emailCode: '',
            sendBtnText: '发送验证码',
            sendLimitTime: 0
        }
    },
    methods: {
        setPanelPosition () {
            let h = this.$refs.mainDiv.clientHeight
            this.mainTop = this.getClientTop(h)
            this.mainLeft = (window.screen.availWidth - 400) / 2
        },
        switchType (type) {
            if (type === 'mobile') {
                this.typeIsMobile = true
                this.typeIsEmail = false
            } else {
                this.typeIsMobile = false
                this.typeIsEmail = true
            }
            this.sendLimitTime = 0
        },
        sendMobileCode () {
            if (this.sendLimitTime > 0) {
                return
            }
            let that = this
            if (this.isEmpty(this.mobile)) {
                this.showError('请输入手机号')
                return
            }
            this.$ajax.post('/api/mobileverify/send', {
                mobile: this.mobile,
                type: 2
            }).then(function (res) {
                that.sendLimitTime = 60
                that.decBtnTime()
            })
        },
        sendEmailCode () {
            if (this.sendLimitTime > 0) {
                return
            }
            let that = this
            if (this.isEmpty(this.email)) {
                this.showError('请输入邮箱')
                return
            }
            this.$ajax.post('/api/emailverify/send', {
                email: this.email,
                type: 2
            }).then(function (res) {
                that.sendLimitTime = 60
                that.decBtnTime()
            })
        },
        nextStep () {
            let that = this
            if (this.typeIsMobile) {
                if (this.isEmpty(this.mobile)) {
                    this.showError('请输入手机号')
                    return
                }
                if (this.isEmpty(this.mobileCode)) {
                    this.showError('请输入验证码')
                    return
                }
                this.$ajax.post('/api/mobileverify/verify', {
                    mobile: this.mobile,
                    code: this.mobileCode
                }).then(function (r) {
                    //存储cert
                    localStorage.setItem('getBackCert', r.data.cert)
                    that.$router.push({
                        path: '/set-new-password'
                    })
                })
            } else {
                if (this.isEmpty(this.email)) {
                    this.showError('请输入邮箱')
                    return
                }
                if (this.isEmpty(this.emailCode)) {
                    this.showError('请输入验证码')
                    return
                }
                this.$ajax.post('/api/emailverify/verify', {
                    email: this.email,
                    code: this.emailCode
                }).then(function (r) {
                    //存储cert
                    localStorage.setItem('getBackCert', r.data.cert)
                    that.$router.push({
                        path: '/set-new-password'
                    })
                })
            }
        },
        decBtnTime () {
            if (this.sendLimitTime === 0) {
                this.sendBtnText = '发送验证码'
            } else {
                this.sendLimitTime--
                this.sendBtnText = this.sendLimitTime + 'S'
                let that = this
                setTimeout(function () {
                    that.decBtnTime()
                }, 1000)
            }
        }
    }
}
</script>

<style scoped>

.divSwitch {
    text-align: center;
    margin-top: 60px;
}

.divSwitch span {
    cursor: pointer;
    padding-bottom: 3px;
}

.spanSelected {
    color: #00a4e0;
    border-bottom: 1px #00a4e0 solid;
}

.divInput {
    padding-top: 1em;
    padding-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/login/GetBackPassword.vue